import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * This is a base class for components rendered within Google Maps.
 * Subclasses are expected to define the initialize() method, which returns
 * the Google Maps API object reference to be added to the map.
 */

export default class GoogleMapComponent extends Component {
  // eslint-disable-line react/require-render-return

  static contextTypes = {
    map: PropTypes.object,
  };

  componentDidMount() {
    this.ref = this.initialize(this.props);
    if (this.ref) this.ref.setMap(this.context.map);
  }

  componentDidUpdate() {
    this.update(this.props);
  }

  componentWillUnmount() {
    if (this.destroy) this.destroy();
    if (this.ref) this.ref.setMap(null);
  }

  initialize() {
    console.warn('GoogleMapComponents must define an `initialize` method.'); // eslint-disable-line no-console
    return new google.maps.Marker();
  }

  update(nextProps) {
    if (this.ref instanceof google.maps.OverlayView) {
      this.ref.setProps(nextProps);
      this.ref.draw();
    } else {
      if (this.ref) this.ref.setMap(null);
      this.ref = this.initialize(nextProps);
      if (this.ref) this.ref.setMap(this.context.map);
    }
  }

  render() {
    return null;
  }
}
